import { path } from '~/routes/path'

// Hàm xử lý trả về url của category trong màn menu
export const getURLCategory = (idCategory) => {
  const urlMenu = path.indexMenu
  const URL = `${urlMenu}?category_ID=${idCategory}`

  return URL
}

// Hàm xử lý trả về url của category trong màn menu tablet
export const getURLCategoryInIndexMenu = (idCategory, idBigCategory) => {
  const urlMenuTablet = path.indexMenuTablet
  let URL = `${urlMenuTablet}?category_ID=${idCategory}`
  if (idBigCategory) {
    URL += `&big_category_ID=${idBigCategory}`
  }

  return URL
}
